// @flow

import Category from 'model/Category';
import marketplace from 'data/products/marketplace';

export default new Category('apps', marketplace);
